
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 20","fill":"red","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.856 5.531v11.916A2.56 2.56 0 003.422 20h7.7a2.56 2.56 0 002.568-2.553V5.53H.856zM4.28 17.317c0 .31-.192.56-.429.56h-.43c-.237 0-.429-.25-.429-.56V7.788c0-.298.18-.537.405-.554h.478c.225.017.405.256.405.554v9.529zm3.85 0c0 .31-.192.56-.429.56h-.859c-.237 0-.429-.25-.429-.56V7.788c0-.298.18-.537.405-.554h.907c.225.017.405.256.405.554v9.529zm3.421-9.529v9.529c0 .31-.192.56-.43.56h-.429c-.236 0-.428-.25-.428-.56V7.788c0-.298.18-.537.405-.554h.477c.226.017.405.256.405.554zm2.138-5.66H.856a.854.854 0 00-.856.85v.426c0 .47.383.851.856.851H13.69c.472 0 .856-.38.856-.851v-.426a.853.853 0 00-.856-.85z"}}),_c('path',{attrs:{"d":"M6.264 0h2.17c.473 0 .856.381.856.851v.425c0 .47-.383.851-.856.851h-2.17a.853.853 0 01-.856-.85V.85c0-.47.383-.851.856-.851z"}})])
          )
        }
      }
    